// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__nJrj9","input":"style_input__i26A2"};